import AppDispatcher from '../utils/AppDispatcher';
import { EventEmitter } from 'events';
import { events as PosEvents } from '../constants/PosConstants';
import { getApiUrl } from '../utils/ApiUrls';

/*
    We should be able reduce this file to almost nothing eventually.
    1) API should always hit  / (done)
    2) remove Google Analytics,  printReceipt, printLabel, isMac
    3) cutover the manifest system so we can stop hitting the report server
    
    At that point we should have one state config that's returned regardless of the app location.
    GetState can return that and the dictionary and getRegion can go away.
*/

var platform        = window.navigator.platform,
    macosPlatforms  = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
    href            = window.location.href;

var _state = {
    host: false,
    useAutoLogin: false,
    region: false,
    dev : {
        googleAnalytics : 'UA-102672730-1',
        api             : '/',
        url             : '//test-leaflogixpos.azurewebsites.net/',
        printLabel      : '',
        printManifest   : '',
        printReceipt    : (macosPlatforms.indexOf(platform) !== -1 ? '//printapp.azurewebsites.net/Print.aspx' : '//printreceipt-live.azurewebsites.net/DemoPrintFile/Index'),
        isMac           : macosPlatforms.indexOf(platform) !== -1,
        shortManifest   : '//md-westlive-rpt.azurewebsites.net/ManifestShort.aspx?',
        printManifest2  : '',
    },
    version             : '2.0 Beta',
    buildnumber         : '',
    forceRefresh        : false,
};

class ConfigStoreClass extends EventEmitter {

    constructor () {
        super();
        
    }

    useAutoLogin() {
        return _state.useAutoLogin;
    }

    getVersion() {
        return _state.version;
    }

    getBuildNumber() {
        return _state.buildnumber;
    }

    getForceRefresh() {
        return _state.forceRefresh;
    }

    getState() {
        var host = _state.dev;
        const config = getApiUrl();
        if(config){
            return config;
        }

        return host;
    }

    getRegion() {
        if(_state.region) {
            return _state.region;
        }
    }

    isDev() {
        if (href.indexOf('localhost') !== -1)
            return true;

        return false;
    }

    emitChange(event, data) {
        this.emit(event, data);
    }

    addChangeListener(event, callback) {
        this.on(event, callback);
    }

    removeChangeListener(event, callback) {
        this.removeListener(event, callback);
    }
}

const ConfigStore = new ConfigStoreClass();

ConfigStore.dispatchToken = AppDispatcher.register(action => {

    switch(action.actionType) {
        case PosEvents.BUILD_NUMBER:
            _state.buildnumber = action.data.number;
            _state.forceRefresh = action.data.forceRefresh;
            ConfigStore.emitChange(PosEvents.BUILD_NUMBER, action.data.number);
            break;
        case PosEvents.REGION:
            _state.region = action.data;
            ConfigStore.emitChange(PosEvents.REGION_EVENT, action.data);
            break;
    }
});

export default ConfigStore;



// WEBPACK FOOTER //
// ./ui_src/app/stores/ConfigStore.jsx